export default "__VITE_ASSET__CJ3PUH7p__"